import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

interface EnvironmentConfig {
  apiUrl: string;
  currentUrl: string;
  ioApplicationUrl?: string;
}

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private readonly IO_SEGMENT = 'v2';
  public static readonly STAGES = ['prod', 'dev', 'test', 'local', 'awb'] as const;
  private readonly IO_CONFIG: Record<Stage, EnvironmentConfig>;
  private readonly IA_CONFIG: Record<Stage, EnvironmentConfig>;

  constructor() {
    this.IO_CONFIG = {
      prod: { apiUrl: 'https://6x6hep4ey9.execute-api.eu-central-1.amazonaws.com/production', currentUrl: 'https://originality-report.inspera.com/',ioApplicationUrl:'https://app-originality.inspera.com/' },
      dev: { apiUrl: 'https://nm58vmtm0b.execute-api.eu-central-1.amazonaws.com/dev', currentUrl: 'https://d20y34nzxtn3fz.cloudfront.net/',ioApplicationUrl:'https://d252tz0djuu42k.cloudfront.net/' },
      test: { apiUrl: 'https://ja0ot1lhh6.execute-api.eu-central-1.amazonaws.com/test', currentUrl: 'https://dr1jb08byj1tg.cloudfront.net/',ioApplicationUrl:'https://d1bca1svxbo4ej.cloudfront.net/' },
      local: { apiUrl: 'http://localhost:3000/elastic', currentUrl: 'http://localhost:4300/',ioApplicationUrl:'http://localhost:4200/' },
      awb: { apiUrl: 'https://backend-io.awb.inspera.com/elastic', currentUrl: 'https://originality-report.awb.inspera.com/',ioApplicationUrl:'https://app-originality.awb.inspera.com/' }
    };
    this.IA_CONFIG = {
      prod: { apiUrl: 'https://154i7j3up4.execute-api.eu-central-1.amazonaws.com/production', currentUrl: 'https://originality-report.inspera.com/' },
      dev: { apiUrl: 'https://mderh1sy0b.execute-api.eu-central-1.amazonaws.com/development', currentUrl: 'https://d20y34nzxtn3fz.cloudfront.net/' },
      test: { apiUrl: 'https://laasttfl8h.execute-api.eu-central-1.amazonaws.com/testing', currentUrl: 'https://dr1jb08byj1tg.cloudfront.net/' },
      local: { apiUrl: 'http://localhost:3000/elastic', currentUrl: 'http://localhost:4300/' },
      awb: { apiUrl: 'http://localhost:3000/elastic', currentUrl: 'http://localhost:4300/' }
    };
  }

  setEnvironmentBasedOnRoute() {

    const isIO = !window.location.pathname.split('/').includes("Inspera");
    console.log(isIO, 'isIO');

    const stage = this.getStage(isIO);
    console.log(stage, 'stage');
    this.setEnvironmentVariables(isIO, stage);


    // console.log(environment,"environment");


    // const isIO = environment.standalone;
    // console.log(isIO, 'isIO');



    // const stage = this.getStage(isIO);
    // console.log(stage, 'stage');
    // this.setEnvironmentVariables(isIO, stage);
  }

  private getStage(isIO: boolean): Stage {
    const stageKey = isIO ? 'IOstage' : 'IAstage';
    const stage = environment[stageKey] as Stage;
    return EnvironmentService.STAGES.includes(stage) ? stage : 'prod';
  }

  private setEnvironmentVariables(isIO: boolean, stage: Stage) {
    const config = isIO ? this.IO_CONFIG[stage] : this.IA_CONFIG[stage];
    environment.apiUrl = config.apiUrl;
    environment.currentUrl = config.currentUrl;
    environment.production = stage === 'prod';
    environment.ioApplicationUrl = config.ioApplicationUrl;
  }
}

type Stage = (typeof EnvironmentService.STAGES)[number];
